(function () {
	const scrollShowcase = () => {
		const box = document.querySelector(".scroll-showcase-box");
		const items = document.querySelectorAll(".scroll-showcase_item");
		let activeIndex = 0;
		let scrollCount = 0;
		const isMobile = window.matchMedia('(max-width: 749px)').matches;
		const scrollThreshold = isMobile ? 3 : 7;
		let listenersBound = false;
		const windowHeight = window.innerHeight;

		const setActiveImage = (index, opacity, scale) => {
			items.forEach((item, i) => {
				if (i < index) {

					item.style.transition = "transform 0.5s";
					
				} else {

					item.style.opacity = 0;
					item.style.transform = "scale(0.8)";
					item.style.transition = "transform 0.5s";
				}
			});



			if (index >= 0 ) {
				items[index].style.opacity = opacity;
			items[index].style.transform = `scale(${
				scale
			})`;
			}
				
			
			
		};

		const handleScrollInsideSection = (event) => {
	
			
			const delta = event.deltaY;
			const step = Math.max(1, Math.round(Math.abs(delta) / 20));
			if (delta > 0) {
				//console.log(scrollCount, "ijneluc")
			
				scrollCount += step;
				
				if (scrollCount <= scrollThreshold) {
	

					const opacity = 0.2 + (scrollCount / scrollThreshold) * 0.8;
					const scale = 0.8 + (scrollCount / scrollThreshold) * 0.2;

					setActiveImage(activeIndex, opacity, scale);
				}
				if (scrollCount >= scrollThreshold && activeIndex < items.length - 1) {
		

					activeIndex++;
					scrollCount = 0;
					setActiveImage(activeIndex, 0.2, 0.8);
				}
				//console.log("111111",scrollCount)
	
			} else if (delta < 0) {
				//console.log(111,"verev helnel if")
			
				scrollCount += step;
				if (scrollCount <= scrollThreshold && activeIndex >= 0) {
					//console.log(222,"opacity")

					const scale = 1 - (scrollCount / scrollThreshold) * 0.2;
					const opacity = 0.8 - (scrollCount / scrollThreshold) * 0.8;
					setActiveImage(activeIndex, opacity, scale);
				}
				if (scrollCount >= scrollThreshold && activeIndex >= 0) {
					//console.log(333)

					//if (activeIndex > 0) {
						activeIndex--;
					//}
					
					scrollCount = 0;
					//setActiveImage(activeIndex, 1 ,1);
				}
				//console.log(scrollCount)
		
			}

	
		};

		const checkBoxInView = () => {
				if (!box) return;
				if (listenersBound) return;
				// Reveal all items immediately when section enters viewport (mobile & desktop)
				const revealAllImmediate = () => {
					items.forEach((item) => {
						item.style.transition = "none";
						item.style.opacity = 1;
						item.style.transform = "scale(1)";
					});
					listenersBound = true; // prevent re-binding
				};
				const io = new IntersectionObserver((entries, obs) => {
					const entry = entries[0];
					if (entry && entry.isIntersecting) {
						revealAllImmediate();
						obs.disconnect();
					}
				}, { threshold: 0.2 });
				io.observe(box);
		};

		window.addEventListener("scroll", checkBoxInView);

		document.addEventListener("DOMContentLoaded", checkBoxInView);
	};

	document.addEventListener("DOMContentLoaded", function () {
		scrollShowcase();
	});
})();
